import React from 'react';
import styled from 'styled-components/macro';
import { Select } from '../../form-builder/view/RemindersStyledInputs';
import { Typography, IconButton, Tooltip, MenuItem } from '@material-ui/core';
import { Remove as RemoveIcon } from '@material-ui/icons';
import { TextString } from '../../../components/Text';
import { ComparisonBuilder } from '../ComparisonBuilder';
import { AndOr } from '../ConditionBuilder';
import {
  StyledFieldTypeMenuItem,
  FieldTypeIcon
} from '../../form-builder/FormBuilderFieldForm';

const MainConditionWrapper = styled.div`
  position: relative;
  transition: 0.5s;
  opacity: ${({ fade }) => (fade ? '0.33' : '1')};
`;

const AddRemoveBlock = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

const ConditionBuilderInlineView = props => {
  const { setRemovedHovered, firstLinePrefix } = props;

  return (
    <MainConditionWrapper fade={props.removeHovered}>
      <AddRemoveBlock>
        <Tooltip title="Remove condition" arrow>
          <IconButton
            size="small"
            onMouseOver={() => setRemovedHovered(true)}
            onMouseLeave={() => setRemovedHovered(false)}
            onClick={() => props.setDeleteMe(props.condition._id)}
          >
            <RemoveIcon />
          </IconButton>
        </Tooltip>
      </AddRemoveBlock>

      <b>
        {props.i === 0 ? (
          firstLinePrefix
        ) : (
          <AndOr andOr={props.rootAndOr} update={props.updateRootAndOr} />
        )}
      </b>
      <TextString content={'logic.when_the_answer_to'} />

      <Select
        searchable
        variant={props.variant}
        data-testid={`reminders-logicbuilder-condition-select-field-${props.i}`}
        value={(props.compareType && props.input) || ' '}
        onChange={props.updateQuestion}
        placeholder="Choose a question"
        options={props.inputFieldChoices.map(
          ({ internalId: id, uiType, title, lookupInfo }) => ({
            value: id,
            'data-testid': `reminders-logicbuilder-condition-select-field-value-${id}`,
            text: title || `Untitled ${uiType} field`,
            uiType,
            isSubField: lookupInfo && lookupInfo.subFieldInfo            
          })
        )}
        openMenuOptionParser={opt => {
          return (
            <>
              <FieldTypeIcon fieldType={opt.uiType} />
              <span
                style={{
                  maxWidth: 400,
                  display: 'inline-block',
                  whiteSpace: 'normal',
                  width: 'calc(100% - 64px)'
                }}
              >
                <Typography>
                  <TextString content={opt.text} />
                </Typography>
              </span>
            </>
          );
        }}
      />

      {props.comparisons.map(
        ({ _id }, j) =>
          props.compareType && (
            <ComparisonBuilder
              {...{
                ...props,
                j,
                variant: props.variant
              }}
              key={_id || j}
            />
          )
      )}
    </MainConditionWrapper>
  );
};

export default ConditionBuilderInlineView;
